import * as React from "react";

import { renderMenuButton_unstable } from "@fluentui/react-button";

// eslint-disable-next-line no-restricted-imports
import {
  useAppSplitButtonMenuButton,
  AppMenuButtonProps,
} from "@1js/acui-button/lib/Next";
import { useRibbonMenuButtonState } from "../../RibbonFlyoutAnchor/next";
import { useRibbonSplitButtonMenuButtonStyles } from "./useRibbonSplitButtonMenuButtonStyles";
import { useLargeRibbonMenuButtonLabel } from "../../../../../hooks";

export const RibbonSplitButtonMenuButton = React.memo(
  React.forwardRef<HTMLButtonElement, AppMenuButtonProps>((props, ref) => {
    const state = useAppSplitButtonMenuButton(
      {
        ...props,
        children: useLargeRibbonMenuButtonLabel(props),
      },
      ref
    );

    useRibbonMenuButtonState(props, state);

    useRibbonSplitButtonMenuButtonStyles(state);

    return renderMenuButton_unstable(state);
  })
);

RibbonSplitButtonMenuButton.displayName = "next/RibbonSplitButtonMenuButton";
